'use strict';

angular.module('mobile-apps')
	.service('EntryWarnings', ['VARIABLE_EXPRESSIONS', 'GlossaryMain',
		function(VARIABLE_EXPRESSIONS, GlossaryMain) {

			var factory = {};

			/**
			 * Converts the field-names to property-names on the entry
			 */
			var getEntryFieldName = function(fieldName) {
				var entryFieldName = fieldName;
				if (fieldName === 'target') {
					entryFieldName = 'value';
				}

				return entryFieldName;
			};


			// ---------------- CHECK FUNCTIONS ----------------
			// The functions which check if the fields contain valid data.
			// If they return an empty array everything is fine. If they
			// return an array with strings they get displayed as warnings.


			/**
			 * Checks if the source string changed after the entry did
			 */
			var sourceStringChangedCheckFunction = function(fieldName, data) {
				if (data.isMasterLang) {
					// If it is the master language it does not apply
					return [];
				}

				if (!data.entry || !data.base) {
					return [];
				}

				if (!data.entry.valueUpdatedAt) {
					// If the translation does not exist yet there is no date
					return [];
				}

				if (!data.entry.sourceValue || (!data.entry.draft && !data.entry.value)) {
					// Exclude keys without source and completely empty strings from the filter result
					return [];
				}

				var sourceDate = new Date(data.entry.valueUpdatedAt);
				var baseDate = new Date(data.base.valueUpdatedAt);

				if (sourceDate >= baseDate) {
					return [];
				}

				return ['Base language text changed since this translation was saved last.'];
			};


			/**
			 * Checks if the field is <= the allowed maxLength
			 */
			var maxLengthCheckFunction = function(fieldName, data) {
				// Get how long the string is allowed to be
				var maxLength;
				if (data.entry.maxLength === undefined || data.entry.maxLength === 0) {
					// Depends on what kind of data it is
					if (data.isMasterLang) {
						// In master-language it represents also deactivated
						maxLength = undefined;
					} else {
						// In other-language it takes the length of the base
						// language string
						if (data.base && data.base.hasOwnProperty('value') && data.base.value !== undefined && data.base.value !== null) {
							maxLength = data.base.value.length;
						} else {
							// If there is no master-language and no base
							// we do not display the max-length
							maxLength = undefined;
						}
					}
				} else if (data.entry.maxLength === -1) {
					// No length limit
					maxLength = undefined;
				} else {
					// Length got set manually
					maxLength = data.entry.maxLength;
				}

				// If there is no maxLength nothing can be wrong with the entry
				if (maxLength === undefined) {
					return [];
				}

				// Get the field name we want to display to the user and
				// how it is defined on the entry
				var entryFieldName = getEntryFieldName(fieldName);
				var displayFieldName = fieldName;
				if (fieldName === 'target') {
					displayFieldName = 'translation';
				}

				// Get the length of the property
				var translationLength = 0;
				if (data.entry.hasOwnProperty(entryFieldName) && data.entry[entryFieldName] !== undefined && data.entry[entryFieldName] !== null && data.entry[entryFieldName].length > maxLength) {
					translationLength = Math.max(translationLength, data.entry[entryFieldName].length);
				}

				// Check if the string has the correct length
				if (translationLength > maxLength) {
					var referenceText = 'the base language text.';
					if (data.entry.hasOwnProperty('maxLength') && data.entry.maxLength > 0) {
						referenceText = 'allowed.';
					}

					var characterDifference = translationLength-maxLength;
					var characterText = '';
					if (characterDifference === 1) {
						characterText += characterDifference + ' character';
					} else {
						characterText += characterDifference + ' characters';
					}

					return ['The ' + displayFieldName + ' is ' + characterText + ' longer than ' + referenceText];
				}

				return [];
			};

			/**
			 * Checks if the variables which got used in the source got also
			 * used in the translation
			 */
			var variableMissingCheckFunction = function(fieldName, data) {
				var entryFieldName = getEntryFieldName(fieldName);
				var displayFieldName = fieldName;
				if (fieldName === 'target') {
					displayFieldName = 'translation';
				}

				if (data.isMasterLang) {
					// If it is the master language it does not apply
					return [];
				}

				if (!data.entry.hasOwnProperty(entryFieldName) || !data.base || !data.base.value) {
					// If the entry or base-entry do not have the needed values
					return [];
				}

				if (data.entry[entryFieldName] === '') {
					// Unless some value is set we ignore the variable-check.
					return [];
				}

				var errorMessages = [];
				VARIABLE_EXPRESSIONS.forEach(function(regex) {
					// Check if the base-entry has variables
					var baseEntryVariables = data.base.value.match(regex);
					if (!baseEntryVariables) {
						// Base entry does not have any variables
						return [];
					}

					// Storing possible identical vars to proper check
					// if there's any var still not placed on entry value
					var baseIndex = 0;
					var identicalVars = {};
					baseEntryVariables.forEach(function(item) {
						identicalVars[item] = identicalVars[item] || [];
						identicalVars[item].push(baseIndex++);
					});  
					  
					baseEntryVariables.forEach(function(variableName) {
						if (!data.entry[entryFieldName] || data.entry[entryFieldName].indexOf(variableName) === -1) {
							// Variable is missing
							errorMessages.push('Variable "' + variableName + '" missing in field: ' + displayFieldName);
						} else if(identicalVars[variableName] && identicalVars[variableName].length > 1){ // Checking if there're identical vars for the current variableName iteration, to notify the user
							var entryText = data.entry[entryFieldName];
							// Looping over identical vars and making  
							// substrings from entry value to find the 
							// next not placed var
							for (var index = 0; index < identicalVars[variableName].length - 1; index++) {
								var varMatchIndex = entryText.indexOf(variableName) + variableName.length;
								entryText = entryText.substring(varMatchIndex);
								
								if (entryText.indexOf(variableName) === -1) {
									// If anyone found, notifying the user
									errorMessages.push('Variable "' + variableName + '" missing in field: ' + displayFieldName);
									
									// Since already notified about this not-placed var
									// we remove one from the stack so that in the next
									// iteration dont repeat same operation
									if(identicalVars[variableName]){
										identicalVars[variableName].shift();
									}
								} else if (index === identicalVars[variableName].length - 2){ 
									// Matching all special characters so that we can
									// escape them avoiding posible rendering and console errors 
									var escapedVariableName = variableName.replace(/[^A-Za-z0-9 ]/g, function(letter){ return '\\' + letter; });
									
									// If last iteration, we remove current iterating var from entryText
									// so that on the baseEntryVariables next iteration doesnt repeat same operation, 
									// since at this step, still there's at least one var remaining.
									entryText = entryText.replace(new RegExp(escapedVariableName, 'g'), '');
								}
							}
						}
					});
				});

				return errorMessages;
			};

			/**
			 * Checks if the glossary terms which got used in the source got
			 * also used in the translation
			 */
			var glossaryCheckFunction = function(fieldName, data) {
				var entryFieldName = getEntryFieldName(fieldName);
				var displayFieldName = fieldName;
				if (fieldName === 'target') {
					displayFieldName = 'translation';
				}

				var errorMessages = [];

				if (!data || !data.languages || !data.languages.base || !data.languages.entry) {
					// If we do not know which languages are used skip it because
					// that information is needed for the check
					return [];
				}

				if (data.languages.base === data.languages.entry) {
					// If the languages are the same we are in the base language
					// and there is nothing to do
					return [];
				}

				if (data.entry[entryFieldName] === '') {
					// Unless some value is set we ignore the variable-check.
					return [];
				}

				var baseLanguageValue, checkValue;

				for (var entryId in GlossaryMain.entries) {
					var entryTranslations = GlossaryMain.entries[entryId].translations;
					// Check first if there is really a value set for the base
					// language
					if (entryTranslations.hasOwnProperty(data.languages.base)) {
						baseLanguageValue = entryTranslations[data.languages.base];

						if (data.base && data.base.value && data.base.value.indexOf(baseLanguageValue) !== -1) {
							// The glossary entry value is in the base entry

							if (entryTranslations.hasOwnProperty(data.languages.entry)) {
								// If there is a value in the language defined use it
								checkValue = entryTranslations[data.languages.entry];
							} else {
								// If there is no value for the language use base one
								checkValue = baseLanguageValue;
							}

							// Check if the needed word can be found in the translation
							if (data.entry[entryFieldName] && data.entry[entryFieldName].indexOf(checkValue) === -1) {
								errorMessages.push('The glossary term "' + checkValue + '" is missing in field: ' + displayFieldName);
							}
						}

					}
				}

				return errorMessages;
			};


			// Defines for which fields which check functions should run
			factory.fieldCheckFunctions = {
				'draft': [
					maxLengthCheckFunction,
					variableMissingCheckFunction,
					glossaryCheckFunction
				],
				'source': [
					sourceStringChangedCheckFunction
				],
				'target': [
					maxLengthCheckFunction,
					variableMissingCheckFunction,
					glossaryCheckFunction
				]
			};


			/**
			 * Returns the warning messages for the fields from the predefined
			 * check functions
			 * @param warningFields The fields to check
			 * @param data The data to check
			 * @returns {Array}
       		 */
			factory.getWarningMessages = function(warningFields, data) {
				var me = this;
				return me.runCheckFunctions(warningFields, data, me.fieldCheckFunctions);
			};


			/**
			 * Returns the warning messages for the fields from the given
			 * check functions
			 * @param warningFields The fields to check
			 * @param data The data to check
			 * @param checkFunctions The check functions to execute for the given fields
			 * @returns {Array}
			 */
			factory.runCheckFunctions = function(warningFields, data, fieldCheckFunctions) {
				var warningMessages = [];

				// Go through all the fields we want to get the warnings of
				warningFields.forEach(function(fieldName) {
					if (fieldCheckFunctions.hasOwnProperty(fieldName)) {
						// Go through all the check functions that are defined
						// for the field
						fieldCheckFunctions[fieldName].forEach(function(checkFunction) {
							var warnings = checkFunction(fieldName, data);
							if (Array.isArray(warnings)) {
								// If we got any warnings we display them
								warningMessages.push.apply(warningMessages, warnings);
							}
						});
					}
				});

				return warningMessages;
			};


			factory.checkFunctions = {
				glossaryCheckFunction: glossaryCheckFunction,
				sourceStringChangedCheckFunction: sourceStringChangedCheckFunction,
				maxLengthCheckFunction: maxLengthCheckFunction,
				variableMissingCheckFunction: variableMissingCheckFunction
			};


			return factory;
		}
	]);

